// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"41":"7082d4ba","195":"11fb010e","710":"a2e9af38","821":"505e7d3a"}[chunkId] + ".css";
};